const { VUE_APP_OPEN_ACCOUNT } = process.env
import { post, get, path_version } from '@/httpRequest/http.js'
import store from '@/store/openAccount'
import { getBaseUrl } from '@/utils'

const baseUrl = getBaseUrl(VUE_APP_OPEN_ACCOUNT)

/** 提交用户信息
 * @data 需要提交给后端的数据
 * @isHalf 是否为上一步的保存
 * @step 传入固定的步骤  不再依赖计算的步骤
 */
export const ApplyUpdate = (data, isHalf = false, step = null) => {
    // store.getters['account/getUserInfo'] 这种方式获取数据不对
    // const { appId, stepVersion, currentStep } = store.state.account
    const { appId, stepVersion, currentStep } = store.getters['account/getUserInfo']
    console.log('currentStep: ', {
        currentStep,
        step,
        msg: '优先使用step',
    })

    return post(baseUrl + '/kyc/v1/ApplyUpdate', {
        data: {
            appId,
            stepVersion,
            currentStep: isHalf ? '' : step || currentStep,
            data,
        },
    })
}

/** 设置开户类型 内地开户｜ 香港开户 */
export const ApplySwitch = data => {
    return post(baseUrl + '/kyc/v1/ApplySwitch', {
        data,
    })
}

/** 查询公司列表
 * params
 */
export const CompanySearch = data => {
    return get(baseUrl + `/kyc/v1/CompanySearch?`, {
        params: data,
    })
}

/** 查询公司信息 */
export const CompanyInfo = data => {
    return get(baseUrl + `/kyc/v1/CompanyInfo?`, {
        params: data,
    })
}

/** 身份证 OCR */
export const IdcardOcr = data => {
    return post(baseUrl + '/kyc/v1/IdcardOcr', {
        data,
        timeout: 60000,
    })
}

/** 银行卡 OCR */
export const BankCardOcr = data => {
    return post(baseUrl + '/kyc/v1/BankcardOcr', {
        data,
        timeout: 60000,
    })
}

// faceID
export const LivingBodyVerifyRaw = data => {
    return post(baseUrl + '/kyc/v1/LivingBodyVerifyRaw', {
        data,
        timeout: 60000, // 人脸设置为一分钟
    })
}

// 申请CA证书
export const ApplyCACert = () => {
    const { appId } = store.getters['account/getUserInfo']

    return post(baseUrl + '/kyc/v1/ApplyCACert', {
        data: {
            appId,
        },
    })
}

/** 提交完毕 */
export const ApplySubmit = () => {
    const { appId } = store.getters['account/getUserInfo']

    return post(baseUrl + '/kyc/v1/ApplySubmit', {
        data: {
            appId,
        },
        timeout: 30000,
    })
}

/** 将中文内容转成拼音 */
export const KYCKeyValue = data => {
    return post(baseUrl + `/kyc/${path_version}/KYCKeyValue?`, {
        data: data,
    })
}

/** 反洗钱风险检查接口  */
export const ApplyAmlCheck = data => {
    return post(baseUrl + `/kyc/v1/ApplyAmlCheck?`, {
        data: data,
    })
}
